<div class="robot-rules-container task">
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">{{ "robot.message.title.condition" | translate }}</div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.condition.label_event" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <span>{{ "automation.task_rule.condition.text.approach_checkout" | translate }}</span>
          </div>
        </div>
      </div>

      <widget-rule-form-item-house-picker
        [data]="$any(scopeHouses)"
        [showRoomTypeTip]="false"
        (onChange)="scopeHouses = $event"></widget-rule-form-item-house-picker>
    </div>
  </div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      <!-- 开始任务 -->
      {{ "automation.task_rule.action.title.start" | translate }}
      <!-- {{ "robot.task.title.action1" | translate }} -->
    </div>
    <div class="block-list">
      <div class="v4-layout-field">
        <span class="v4-layout-field-label">{{ "robot.rule.action.task_label_time" | translate }}</span>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            <nz-select
              class="w-[150px] mr-[12px]"
              nzSize="large"
              [nzDropdownMatchSelectWidth]="false"
              [nzOptions]="triggerType === 'checkin' ? optionsOfCheckinOffsetDay : optionsOfCheckoutOffsetDay"
              [(ngModel)]="offsetDays"></nz-select>
            <nz-select
              class="w-[120px]"
              nzSize="large"
              [nzDropdownMatchSelectWidth]="false"
              [nzOptions]="optionsOfTriggerType"
              [(ngModel)]="triggerType"></nz-select>
            <!-- <span>
              {{ "automation.task_rule.action.text.checkout" | translate }}
            </span> -->
          </div>
          <div class="v4-layout-field-extra">
            <span class="desc">
              {{ "automation.task_rule.action.text.checkout_tip" | translate }}
              <!-- 任务的具体时间将在相关订单变为退房时自动设置 -->
              <!-- {{ "robot.rule.action.task_type1" | translate }} -->
            </span>
          </div>
        </div>
      </div>

      <ng-container [formGroup]="actionTaskForm">
        <div class="v4-layout-field">
          <span class="v4-layout-field-label">{{ "robot.rule.action.label_assignee" | translate }}</span>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <nz-select
                nzSize="large"
                formControlName="assigned_person"
                [nzOptions]="optionsOfCleander"
                [nzPlaceHolder]="'robot.rule.action.placeholder_assignee' | translate"></nz-select>
            </div>
            <div class="v4-layout-field-extra">
              <span class="desc">{{ "robot.rule.action.assignee_tip" | translate }}</span>
            </div>
          </div>
        </div>
        <div class="v4-layout-field">
          <span class="v4-layout-field-label">{{ "robot.rule.action.label_task_desc" | translate }}</span>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row relative">
              <textarea
                #textarea
                formControlName="description"
                rows="6"
                nz-input
                nzAutosize
                [placeholder]="'robot.rule.action.placeholder_task_desc' | translate"></textarea>
              <div class="absolute bottom-[1px] left-[10px] right-[20px] py-[10px] bg-white">
                <host-dyn-content-picker
                  [listOfDynContentOption]="listOfDynContentOption"
                  (onSelect)="onSelectDynContent($event)"></host-dyn-content-picker>
              </div>
            </div>
          </div>
        </div>

        <div class="v4-layout-field">
          <div class="v4-layout-field-label">{{ "task.word.check_list" | translate }}</div>
          <div class="v4-layout-field-control">
            @for (item of checkList; track $index; let last = $last) {
              <div class="v4-layout-field-row" [ngClass]="{ 'mb-[12px]': !last }">
                <input
                  type="text"
                  nz-input
                  nzSize="large"
                  [(ngModel)]="item.title"
                  [ngModelOptions]="{ standalone: true }" />
                <span
                  class="ml-[18px] cursor-pointer"
                  nz-icon
                  nzType="close-circle"
                  nzTheme="outline"
                  (click)="onRemoveCheckList($index)"></span>
              </div>
            }
            <div class="leading-[42px]">
              <span class="text-primary cursor-pointer" (click)="onAddCheckList()"
                >+ {{ "create-task_html_add_item" | translate }}</span
              >
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="flex flex-row items-center justify-between pt-[30px]">
    <div class="left"></div>
    <div class="ml-auto">
      <button class="mr-3" nz-button nzSize="large" (click)="onCancel()">{{ "word.cancel" | translate }}</button>
      <button nz-button nzSize="large" nzType="primary" (click)="onSave()">{{ "word.save" | translate }}</button>
    </div>
  </div>
</div>
